'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders an icon which will notify its parent when it's clicked.
 * @extends {Component}
 */
var ExpandableHintComponent = function (_React$Component) {
  _inherits(ExpandableHintComponent, _React$Component);

  function ExpandableHintComponent() {
    _classCallCheck(this, ExpandableHintComponent);

    return _possibleConstructorReturn(this, (ExpandableHintComponent.__proto__ || Object.getPrototypeOf(ExpandableHintComponent)).apply(this, arguments));
  }

  _createClass(ExpandableHintComponent, [{
    key: 'generateContent',


    /**
     * Returns the content for the hint overlay.
     * @returns {Popover}
     */

    value: function generateContent(hintContent) {
      return this.props.isHintRawHtml ? hintContent.replace(/class=['"][\w- ]+['"]/g, '') : hintContent;
    }
  }, {
    key: 'generateOverlay',
    value: function generateOverlay() {
      if (this.props.hintStatus) {
        return _react2.default.createElement(
          _reactBootstrap.Panel,
          { collapsible: true, expanded: this.props.hintStatus, id: this.props.hintId, header: !this.props.isHintRawHtml ? this.props.hintTitle : null },
          _react2.default.createElement('div', {
            dangerouslySetInnerHTML: {
              __html: this.generateContent(this.props.hintContent)
            }
          })
        );
      }
      return undefined;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.generateOverlay()
      );
    }
  }]);

  return ExpandableHintComponent;
}(_react2.default.Component);

ExpandableHintComponent.propTypes = {
  hintId: _react2.default.PropTypes.string.isRequired,
  hintContent: _react2.default.PropTypes.string.isRequired,
  hintStatus: _react2.default.PropTypes.bool,
  hintTitle: _react2.default.PropTypes.string,
  isHintRawHtml: _react2.default.PropTypes.bool
};
exports.default = ExpandableHintComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/input/ExpandableHintComponent.jsx
// module id = 209
// module chunks = 0